import { getToken, getUserStored } from "./token";
import {HttpClient} from "@/services/httpClient";

const host = process.env.VUE_APP_PROD_URL;

var headers = new Headers();
headers.append("Authorization", `Bearer ${getToken()}`);

export const getProfileInfo = async () => {
  headers.append("Content-Type", "application/json");
  let response = await fetch(`${host}api/v1/me/profile/`, {
    headers,
    method: "GET",
  });
  return response.json();
};

export const userGroups = () => {
  return getUserStored().profile.groups;
};

export const userData = () => {
  return getUserStored().data;
};
export const userLoginData = () => {
  return getUserStored().profile;
};
//ACH 16/04/2024 metodo para obtener el usuario
export const userSiaData = () => {
  return getUserStored().sia;
};

export const setPassword = async (data) => {
  let url = `${host}api/v1/cuenta/empresa/password/`;
  let bodyData = JSON.stringify(data);
  let response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: bodyData,
  });
  return response.json();
};

export const getAdditionalProfileInfo = async () => {
  let url = `${host}api/v1/aditional-profile/`;
  let response = await fetch(url, { headers });
  return response.json();
};

export const getUserType = (tipo_tramitador=null) => {
  let { empresas_asociadas } = getUserStored();
  if (empresas_asociadas) {
    let selectedCompany = localStorage.getItem("selected_company");
    return empresas_asociadas.find((item) => item === selectedCompany);
  }
  let { empresa, persona_natural, persona_tramitador } = getUserStored();
  //ACH 10/04/2024
  if (tipo_tramitador=='normal') {
    let {data} = getUserStored();
    return data;
  }else if (tipo_tramitador=='sia') {
    let {sia} = getUserStored();
    return sia;
  }else {
    return empresa || persona_natural || persona_tramitador;
  }
  
};

/**
 *
 * @returns {Boolean}
 */
export const userIsAdmin = () => {
  return getUserStored().profile.groups.includes("interno-aprobar-solicitudes");
};

export const userIsCompany = () => {
  return getUserStored().profile.groups.includes("externo-empresa");
};

export const userIsPerson = () => {
  return getUserStored().profile.groups.includes("externo-persona-natural");
};

export const userIsProcessor = () => {
  return getUserStored().profile.groups.includes("externo-tramitador");
};

export const userIsVeterinary = () => {
  return getUserStored().profile.groups.includes("externo-tramitador-veterinario");
};

export const userIsCreator = () => {
  return getUserStored().profile.groups.includes("interno-creador-tramite");
};

export const userIsSystemNal = () => {
    return getUserStored().profile.groups.includes("interno-sia-sistemas-nacional");
}

export const processorId = () => {
  return getUserStored().persona_tramitador;
};

export const getEnabledUsers = async (id_soliciud_tramite) =>{
  headers.append("Content-Type", "application/json");
  let response = await fetch(`${host}api/v1/admin/solicitud-tramite/${id_soliciud_tramite}/usuarios/`, {
    headers,
    method: "GET",
  });
  return response.json();
}

export const getEnabledRolesUsers = async (id_soliciud_tramite) =>{
  const client = new HttpClient();
  return  client.get(`admin/solicitud-tramite/${id_soliciud_tramite}/roles/`);
}


export const getEnabledUsersByRoles = async (id_soliciud_tramite, slug) =>{
  const client = new HttpClient();
  return  client.get(
    `admin/solicitud-tramite/${id_soliciud_tramite}/usuarios/`,
    {slug: slug}
  );
}

export const asignProcedureToUser = async (id_soliciud_tramite,data) =>{
  const headers = new Headers();
  headers.append("Authorization", `Bearer ${getToken()}`);
  const formdata = new FormData();
  formdata.append("fid_usuario", data.fid_usuario);
  formdata.append("motivo", data.motivo);
  let response = await fetch(`${host}api/v1/admin/solicitud-tramite/${id_soliciud_tramite}/asignacion/`, {
    headers,
    method: "POST",
    body: formdata,
  });
  return response.json();
}